import {
    mapProductsForList,
    mapProductsForOne,
    mapStatesForList,
    mapStatesForOne,
} from './common';

function mapGetOnePlatformData(responseData) {
    return {
        ...responseData,
        ...mapProductsForOne(responseData),
        ...mapStatesForOne(responseData),
    };
}

function mapGetListPlatformsData(responseData) {
    return responseData.map((data) => ({
        ...data,
        ...mapProductsForList(data),
        ...mapStatesForList(data),
    }));
}

export { mapGetOnePlatformData, mapGetListPlatformsData };
